import * as moment from 'moment';
import EventBus from '@/helpers/event-bus';
import SectorSubmissionService, { groupeSectorSubmissions } from '@/services/SectorSubmission/SectorSubmission';
import { setStoreValue } from '@/store/modules/storeHelpers';


const state = {
    sectorSubmissions: [],
};

const actions = {
    getUserSectorSubmissions({ commit }) {
        return SectorSubmissionService.getSectorSubmissions().then(result => {
            commit('setStoreValue', { key: 'sectorSubmissions', value: result.data });
        });
    },
    save(_, submissionData) {
        return SectorSubmissionService.createSectorSubmission(submissionData).then(() => { });
    },
    async update(_, updateData) {
        const { submission_id } = updateData;

        try {
            const response = await SectorSubmissionService.updateSubmission(submission_id, updateData);
            const { data } = response;

            if (data && data.status === 1) {
                EventBus.$emit('snotifySuccess', 'Submission updated.');
            }
        } catch (error) {
            if (error.response.data.errors.length) {
                EventBus.$emit('snotifyError', error.response.data.errors[0].msg);
            } else {
                EventBus.$emit('snotifyError', 'Submission updated error.');
            }
        }
    }
};

const mutations = {
    setStoreValue,
};

const getters = {
    groupedSectorSubmissions(state) {
        return groupeSectorSubmissions(state.sectorSubmissions);
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
    namespaced: true,
};
